import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the change password view.
 */
export default class changePasswordView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration
        const theme = this.app.config.theme; // Theme configuration

        // Left section for old password input
        const left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    type: 'password',
                    name: 'OldPassword',
                    id: 'OldPassword',
                    label: _('Contraseña Actual'), // Label for old password
                    labelPosition: 'top',
                    placeholder: _('Contraseña Actual'), // Placeholder for old password
                    required: true, // Field is required
                    invalidMessage: _('Campo Requerido'), // Error message for required field
                    on: {
                        onBlur: function () {
                            $$('OldPassword').validate(); // Validate on blur
                        },
                    },
                },
            ],
        };

        // Center left section for new password input
        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'NewPassword',
                    type: 'password',
                    id: 'NewPassword',
                    height: 100,
                    css: 'NewPassword', // Custom CSS class
                    label: _('Nueva Contraseña'), // Label for new password
                    labelPosition: 'top',
                    placeholder: _('Nueva Contraseña'), // Placeholder for new password
                    required: true, // Field is required
                    invalidMessage: _(
                        'La contraseña debe contener mínimo 8 caracteres, una minúscula, una mayúscula y un número.', // Error message for new password validation
                    ),
                    validate: function (value) {
                        // Custom validation for new password
                        return (
                            value.length >= 8 &&
                            /[a-z]/.test(value) &&
                            /[A-Z]/.test(value) &&
                            /[0-9]/.test(value) &&
                            value.indexOf('2020') == -1 &&
                            value.indexOf('2021') == -1 &&
                            value.indexOf('2022') == -1 &&
                            value.indexOf(profile.AgentId) == -1 &&
                            value.indexOf(profile.FirstName) == -1 &&
                            value.indexOf(profile.PartnerName) == -1 &&
                            value.indexOf(profile.CountryName) == -1
                        );
                    },
                    on: {
                        onBlur: function () {
                            $$('NewPassword').validate(); // Validate on blur
                        },
                    },
                },
            ],
        };

        // Center right section for confirm password input
        const center_right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'ConfirmPassword',
                    type: 'password',
                    id: 'ConfirmPassword',
                    label: _('Confirmar Contraseña'), // Label for confirm password
                    labelPosition: 'top',
                    placeholder: _('Confirmar Contraseña'), // Placeholder for confirm password
                    required: true, // Field is required
                    invalidMessage: _('Contraseñas no coinciden'), // Error message for password mismatch
                    validate: function (value) {
                        // Validation to check if confirm password matches new password
                        return value == $$('NewPassword').getValue();
                    },
                    on: {
                        onBlur: function () {
                            $$('ConfirmPassword').validate(); // Validate on blur
                        },
                    },
                },
            ],
        };

        // Upper section containing the password input fields
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left, center_left, center_right], // Layout of password fields
                },
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen

        // Button section for form actions
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Limpiar'), // Clear button
                    autowidth: true,
                    click: () => {
                        $$('formChangePassword').setValues(
                            $$('formChangePassword').getCleanValues(), // Clear form values
                        );
                        $$('formChangePassword').clearValidation(); // Clear validation messages
                    },
                },
                {
                    view: 'button',
                    value: _('Guardar'), // Save button
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        if (this.getRoot().validate()) {
                            // Validate the form
                            const changePassword = this.getRoot().getValues(); // Get form values
                            const cur_user = this.getParam('user', true); // Get current user parameter
                            var cthis = this; // Reference to the current context
                            if (
                                changePassword.NewPassword === changePassword.ConfirmPassword // Check if new password matches confirm password
                            ) {
                                webix.confirm({
                                    type: 'confirm-warning',
                                    text: _('Advertencia!') + '<br/>' + _('Desea cambiar la contraseña?'), // Confirmation message
                                    ok: _('Cambiar Contraseña'), // OK button text
                                    cancel: _('Salir'), // Cancel button text
                                    callback: function (action) {
                                        if (action === true) {
                                            const data = {
                                                OldPassword: changePassword.OldPassword,
                                                NewPassword: changePassword.NewPassword,
                                                ConfirmPassword: changePassword.ConfirmPassword,
                                            };
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type for AJAX request
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Configuration/ChangeMyPassword', // API endpoint for changing password
                                                    data,
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message(
                                                                'Error', // Error message on AJAX failure
                                                            );
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var json = JSON.parse(
                                                                text, // Parse JSON response
                                                            );
                                                            console.log(
                                                                json.AlertMessage, // Log alert message from response
                                                            );
                                                            if (json.HasError) {
                                                                webix.message({
                                                                    text:
                                                                        'Error: ' +
                                                                        _(
                                                                            json.CodeError, // Display error code if there's an error
                                                                        ),
                                                                    title: '¡Error!',
                                                                    type: 'alert-error',
                                                                });
                                                            } else {
                                                                webix.message({
                                                                    text: _(
                                                                        'Contraseña cambiada satisfactoriamente', // Success message
                                                                    ),
                                                                    title: _('¡Exito!'),
                                                                    type: 'alert-warning',
                                                                });
                                                                $$('formChangePassword').setValues(
                                                                    $$('formChangePassword').getCleanValues(), // Clear form values after success
                                                                );
                                                                $$('formChangePassword').clearValidation(); // Clear validation messages
                                                                location.reload(); // Reload the page
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                });
                            } else {
                                webix.message({
                                    title: '¡Error!',
                                    type: 'alert-error',
                                    text: _('Nueva contraseñas no coinciden'), // Error message for password mismatch
                                });
                            }
                        } else {
                            webix.message({
                                title: '¡Error!',
                                type: 'alert-error',
                                text: _('Verifique los campos...'), // Error message for validation failure
                            });
                        }
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            scroll: 'y',
            id: 'formChangePassword', // ID for the form
            rows: [
                {
                    view: 'toolbar',
                    css: theme, // Apply theme to toolbar
                    elements: [
                        { view: 'label', label: _('Cambiar mi contraseña') }, // Label for the toolbar
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            cols: [
                                {
                                    view: 'icon',
                                    icon: 'wxi-close', // Close icon
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => this.show('/top/dashboard'), // Navigate to dashboard on click
                                },
                            ],
                        },
                    ],
                },
                upper_section, // Include upper section with password fields
                buttons, // Include button section
            ],
        };
    }
}

// FILE DOCUMENTED
